import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { msg } from 'api';

import { reportResetConfirmed, reportResetCanceled } from '../utils/SubscriptionsAnalytics';
import Button from 'widgets/Button';
import ConfirmationModal from 'widgets/Modal/ConfirmationModal';

export default class ResetButtonView extends PureComponent {
  static propTypes = {
    resetSubscriptions: PropTypes.func.isRequired,
  }

  state = {
    isConfirmationOpen: false,
  }

  showConfirmation = () => {
    this.setState({
      isConfirmationOpen: true,
    });
  }

  closeConfirmation = () => {
    this.setState({
      isConfirmationOpen: false,
    });
  }

  cancelConfirmation = () => {
    reportResetCanceled();
    this.closeConfirmation();
  }

  resetSubscriptions = () => {
    reportResetConfirmed();
    this.props.resetSubscriptions();
    this.closeConfirmation();
  }

  render() {
    return (
      <div className="sidebar-element no-border">
        <Button
          secondary
          onClick={this.showConfirmation}
          className="subs-resetSubscriptions"
        >
          Reset Regulars
        </Button>
        {this.state.isConfirmationOpen && (
          <ConfirmationModal
            title={msg.subscriptions.reset.title}
            onCancel={this.cancelConfirmation}
            onConfirm={this.resetSubscriptions}
            onCancelLabel="Cancel"
            onConfirmLabel="Reset"
          >
            <p>
              This will reset all your Regulars so that no items are automatically added into your trolley.{' '}
              If you change your mind, you can set up it up again any time.
            </p>
            <p>
              Note: Regulars that have already been added to your trolley this week will not be removed.{' '}
              Once you have reset your Regulars click on ‘View Trolley’ to change or remove products currently added.
            </p>
          </ConfirmationModal>
        )}
      </div>
    );
  }
}
